import { render, staticRenderFns } from "./MessageThreadItem.vue?vue&type=template&id=3cf36972&scoped=true&"
import script from "./MessageThreadItem.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageThreadItem.vue?vue&type=style&index=0&id=3cf36972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf36972",
  null
  
)

export default component.exports